var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4169 4.32166C13.7964 4.32166 16.536 7.06127 16.536 10.4407C16.536 13.8202 13.7964 16.5598 10.4169 16.5598C7.03746 16.5598 4.29786 13.8202 4.29786 10.4407C4.29786 7.06127 7.03746 4.32166 10.4169 4.32166ZM10.4169 3.15613C14.4401 3.15613 17.7015 6.41756 17.7015 10.4407C17.7015 14.4639 14.4401 17.7253 10.4169 17.7253C6.39375 17.7253 3.13232 14.4639 3.13232 10.4407C3.13232 6.41756 6.39375 3.15613 10.4169 3.15613Z",
    fill: "#717B8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.95 15.459C15.1808 15.2347 15.5498 15.24 15.7741 15.4708L19.8352 19.6505C20.0594 19.8813 20.0541 20.2502 19.8233 20.4745C19.5925 20.6988 19.2235 20.6935 18.9992 20.4627L14.9381 16.283C14.7138 16.0522 14.7191 15.6832 14.95 15.459Z",
    fill: "#717B8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8aa457bd32703734ce6d1e0339b93b3a.svg";
export { ForwardRef as ReactComponent };